import { getMRT_RowSelectionHandler as getMRTRowSelectionHandler } from 'material-react-table';
import { List, ListItem, ListItemText } from '@mui/material';

export function tryParse(jsonish) {
  if (jsonish === null) return [];
  try {
    return JSON.parse(jsonish);
  } catch {
    return [];
  }
}

function idfn(x) {
  return x.id;
}

export function defaultTableOptions(selection) {
  return {
    getRowId: idfn,
    enableExpandAll: false,
    enableFacetedValues: true,
    // Not using align: center because it makes the table render too wide for the page
    muiTableHeadCellProps: {
      sx: {
        textAlign: 'center',
        verticalAlign: 'middle',
        '& .Mui-TableHeadCell-Content': {
          justifyContent: 'center',
        },
      },
    },
    muiTableBodyCellProps: { sx: { textAlign: 'center', verticalAlign: 'middle' } },
    muiTableBodyRowProps: ({ row, staticRowIndex, table }) => ({
      onClick: (event) => getMRTRowSelectionHandler({ row, staticRowIndex, table })(event), // import this helper function from material-react-table
      sx: { cursor: 'pointer' },
    }),
    // selection
    enableBatchRowSelection: selection,
    enableMultiRowSelection: selection,
    enableRowSelection: selection,
    enableSelectAll: selection,
  };
}

export function defaultTableInitialState(columnFilters, sorting, expanded = {}) {
  return {
    columnFilters,
    showColumnFilters: columnFilters.length !== 0,
    sorting,
    expanded,
  };
}

export function extractSortingParams(searchParams) {
  return Object.entries(tryParse(searchParams.get('sortBy'))).map(([id, desc]) => ({ id, desc }));
}

export function extractFilterParams(searchParams) {
  return Object.entries(tryParse(searchParams.get('filterBy'))).map(([id, value]) => ({
    id,
    value,
  }));
}

export function extractExpandedParams(searchParams) {
  return Object.fromEntries(tryParse(searchParams.get('expanded', '[]')).map((id) => [id, true]));
}

function identity(params) {
  return params;
}

export function sortingUpdater(sorting) {
  return (updater) => {
    let newSorting = typeof updater === 'function' ? updater(sorting) : updater;
    if (newSorting !== sorting) {
      if (newSorting.length === 0)
        return (params) => {
          params.delete('sortBy');
          return params;
        };
      newSorting = Object.fromEntries(newSorting.map(({ id, desc }) => [id, desc]));
      return (params) => {
        params.set('sortBy', JSON.stringify(newSorting));
        return params;
      };
    }
    return identity;
  };
}

export function filterUpdater(columnFilters) {
  return (updater) => {
    let newColumnFilters = typeof updater === 'function' ? updater(columnFilters) : updater;
    if (newColumnFilters !== columnFilters) {
      if (newColumnFilters.length === 0)
        return (params) => {
          params.delete('filterBy');
          return params;
        };
      newColumnFilters = Object.fromEntries(
        newColumnFilters.map(({ id, value }) => [
          id,
          Array.isArray(value) ? value.map((v) => v || '') : value,
        ])
      );
      return (params) => {
        params.set('filterBy', JSON.stringify(newColumnFilters));
        return params;
      };
    }
    return identity;
  };
}

export function setExpanded(updater, expanded, setSearchParams) {
  let newExpanded = typeof updater === 'function' ? updater(expanded) : updater;

  newExpanded = Object.entries(newExpanded)
    // eslint-disable-next-line no-unused-vars
    .filter(([_, value]) => value)
    // eslint-disable-next-line no-unused-vars
    .map(([key, _]) => key);
  if (newExpanded !== expanded) {
    if (newExpanded.length === 0)
      setSearchParams((params) => {
        params.delete('expanded');
        return params;
      });
    else {
      setSearchParams((params) => {
        params.set('expanded', JSON.stringify(newExpanded));
        return params;
      });
    }
  }
}

export const CellList = (values) => (
  <List>
    {values.map((v) => (
      <ListItem dense key={v}>
        <ListItemText primary={v} />
      </ListItem>
    ))}
  </List>
);

export const parameterUpdater = (key, updater, updaterOrig) => (params) => {
  // Okay to mutate, this is working on a copy
  const values = typeof updater === 'function' ? updater(updaterOrig) : updater;
  params.set(key, JSON.stringify(values));
  return params;
};
export function convertSelectionToList(selection) {
  return (
    Object.entries(selection)
      // eslint-disable-next-line no-unused-vars
      .filter(([_k, v]) => v)
      // eslint-disable-next-line no-unused-vars
      .map(([k, _v]) => parseInt(k, 10) ?? k)
  );
}
